
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import AreaNotesModal from "@/components/area-notes/AreaNotesModal.vue";
import AreaTreePicker from "@/components/form/AreaTreePicker.vue";
import { FeaturesList } from "@/store/types";
import { get } from "lodash";
import { AreaNode } from '@/types/groups/AreaNode';

const AreaNotes = namespace("areaNotes");
const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		"area-notes-modal": AreaNotesModal,
		"area-tree-picker": AreaTreePicker
	}
})
export default class AreaNotesFinder extends Vue {
	@Getter("getFeaturesList") featuresList: FeaturesList;
	@AreaNotes.Mutation setAreaNoteGroupDetails: any;
	@SiteMonitor.Mutation setAreaNotesVisible: any;

	private isModalVisible: boolean = false;
	private selectedTreeItem: AreaNode = null;

	public async show() {
		this.isModalVisible = true;
	}

	public get isEnabled() {
		return get(this.featuresList, ["AreaNotes"]) && get(this.featuresList, ["AreaNotes", "Icons"]);
	}

	private onTreeItemDoubleClicked(treeItem: AreaNode) {
		this.setAreaNoteGroupDetails({ groupId: treeItem.id, groupTitle: treeItem.label });
		this.setAreaNotesVisible(true);
	}

	private showNotesForSelectedGroup(modalEvent) {
		// Prevent the default modal OK button event handling
		// stops the modal being hidden when 'Show Notes' (OK) button is clicked
		modalEvent.preventDefault();

		this.setAreaNoteGroupDetails({ groupId: this.selectedTreeItem.id, groupTitle: this.selectedTreeItem.label });
		this.setAreaNotesVisible(true);
	}

	/**
	 * Handler for when the user selects an item in the area tree.
	 */
	private onTreeItemSelected(treeItem: AreaNode) {
		this.selectedTreeItem = treeItem;
	}
}
